module.exports = __webpack_public_path__ + "static/media/logo-camarasantafilomenamaranhao.dd8635e8.png";